import { createSelector } from "@reduxjs/toolkit";
import { selectInitialFacets } from "./select-initial-facets";
import { selectSelectedFacets } from "./select-selected-facets";
import { FacetStateValues } from "../../models/state/facet-state-values";
import allFacets from "../../constants/all-facets";
import { FacetBase } from "../../models/facet-base/facet-base";
import { FacetTypes } from "../../constants/facet-types-enum";
import { isStringEmpty } from "drh-js-library/dist/drh-string-utils/is-string-empty";
import { Result } from "../../../results/models/result";
import { RangeValues } from "../../models/types/type-range-values";
import { selectMatchedResults } from "../../../results/redux/selectors/facets/select-matched-results";

/** This will return the currently selected visible facets based on the current matched  */
export const selectVisibleFacets = createSelector(
	[selectInitialFacets, selectSelectedFacets, selectMatchedResults],
	(initialFacets, selectedFacets, matchedResults) => {
		//If there are no selected facets just return the initial state
		if (Object.keys(selectedFacets).length === 0) {
			return initialFacets;
		}

		//return initialFacets;

		var visibleFacetValues = {} as FacetStateValues;

		//Loop through all of the items that match the current facets
		for (let index = 0; index < matchedResults.length; index++) {
			const matchedResult = matchedResults[index] as Result;

			//Loop though all of the facets being used in teh CF to see if the results include those values
			for (let index = 0; index < allFacets.length; index++) {
				//Try and get the content from the item
				const drhFacet = allFacets[index] as FacetBase;

				//Get the content from the result
				var resultFacetFieldContent = matchedResult[drhFacet.fieldName];

				switch (drhFacet.type) {
					case FacetTypes.Range:
						var lowValue = 0;
						var highValue = 0;

						//If the facet already exists in the display values, adjust the range
						if (visibleFacetValues[drhFacet.fieldName]) {
							var rangeFacet = visibleFacetValues[
								drhFacet.fieldName
							] as RangeValues;

							var lowestRangeValue = rangeFacet[0];
							var highestRangeValue = rangeFacet[1];

							//If the low value from the result is lower than the currently set lowest
							//replace it.  Ignore 0.
							if (
								resultFacetFieldContent < lowestRangeValue &&
								resultFacetFieldContent !== 0
							) {
								lowestRangeValue = resultFacetFieldContent;
							}

							if (resultFacetFieldContent > highestRangeValue) {
								highestRangeValue = resultFacetFieldContent;
							}

							lowValue = lowestRangeValue;
							highValue = highestRangeValue;
						} else {
							lowValue = resultFacetFieldContent;
							highValue = resultFacetFieldContent;
						}

						visibleFacetValues[drhFacet.fieldName] = [lowValue, highValue];

						break;

					case FacetTypes.Number:
						var facetValue = 0;

						var numberFacetValue = visibleFacetValues[
							drhFacet.fieldName
						] as number;

						//If the facet already exists in the display values, adjust the range
						if (visibleFacetValues[drhFacet.fieldName]) {
							var selectedValue = numberFacetValue;

							if (resultFacetFieldContent[1] > selectedValue) {
								selectedValue = resultFacetFieldContent[1];
							}

							facetValue = selectedValue;
						}
						//If the facet is not in the display values yet, set the initial range
						else {
							facetValue = resultFacetFieldContent[1];
						}

						visibleFacetValues[drhFacet.fieldName] = facetValue;
						break;

					case FacetTypes.Text:
						var resultFacets = [];

						if (Array.isArray(resultFacetFieldContent)) {
							resultFacets = resultFacetFieldContent;
						} else {
							resultFacets.push(resultFacetFieldContent);
						}

						//Loop through any facet values on the current result
						for (let index = 0; index < resultFacets.length; index++) {
							const facetValue = resultFacets[index];

							//If the facet has no values found yet create a new entry in the display values object
							if (!(drhFacet.fieldName in visibleFacetValues)) {
								visibleFacetValues[drhFacet.fieldName] = [];
							}

							//Loop through any facet values in the current result and add them to the overall
							// display values if they are not already there
							var currentTextValues = visibleFacetValues[
								drhFacet.fieldName
							] as string[];

							if (!currentTextValues.includes(facetValue)) {
								if (
									facetValue !== null &&
									facetValue !== undefined &&
									!isStringEmpty(facetValue)
								) {
									currentTextValues.push(facetValue);
								}
							}

							//Set the updated display values
							visibleFacetValues[drhFacet.fieldName] = currentTextValues;
						}

						break;
				}
			}
		}

		return visibleFacetValues;
	},
);
